// extracted by mini-css-extract-plugin
export default {"RichTextInput":"RichTextEditore_RichTextInput__xOmB+","IconPickerWrap":"RichTextEditore_IconPickerWrap__3-p7C"};